const SECOND = 1000;
export const MINUTE = 60 * SECOND;

// Static data that doesn't change, like equipment or accessorial lists
export const STATIC_DATA_STALE_TIME = 10 * MINUTE;

// Data that is queried by many components in a tree and needs a backoff, like shipment details
export const HOT_DATA_STALE_TIME = 3 * SECOND;
